<template>
    <div class="p-fluid" style="direction: rtl">
        <div class="p-p-4 p-grid p-justify-center">
            <select-grade useStore class="p-col-6" navigate-buttons storage-name="Schedule-grade" v-model="gradeSelected"/>
            <Button
                    v-tooltip.top="'הדפסה'"
                    icon="pi pi-print"
                    class="p-col-1 p-mt-2 p-mb-3 p-d-print-none"
                    v-simple-print="'SCHEDULE'"
            />
            <schedule-table :grade="gradeSelected && gradeSelected.id" class="p-col-12"/>
        </div>

    </div>
</template>

<script>

import SelectGrade from "@/components/selects/SelectGrade";
import ScheduleTable from "@/views/Schedule/ScheduleGrade/ScheduleTable.vue";

export default {
    components: {
        SelectGrade,
        ScheduleTable
    },
    data() {
        return {
            gradeSelected: null,
        }
    },
    methods: {
         // onSelectGrade(gradeSelected) {
         //    this.gradeSelected = gradeSelected
        // }
    },
};
</script>


<style scoped>

</style>
